"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTextInfoAppearance = exports.setDefaultItemOnFirst = void 0;
const next_components_text_info_n_1 = require("@gerenciatd/next.components.text-info-n");
const constants_1 = require("../../constants");
const setDefaultItemOnFirst = (menu) => {
    const res = [];
    menu.forEach((item) => {
        if (item.titleBarId && item.titleBarId === 'default') {
            res.unshift(item);
        }
        else {
            res.push(item);
        }
    });
    return res;
};
exports.setDefaultItemOnFirst = setDefaultItemOnFirst;
const setTextInfoAppearance = (segment, selected, isGestor = false) => {
    let color = next_components_text_info_n_1.TEXT_INFO_COLOR.GREY_3;
    let fontType = next_components_text_info_n_1.TEXT_INFO_FONT_WEIGHT.REGULAR;
    // PARTICULARES
    if (segment === constants_1.PARTICULARES) {
        color = next_components_text_info_n_1.TEXT_INFO_COLOR.GREY_4;
        fontType = next_components_text_info_n_1.TEXT_INFO_FONT_WEIGHT.REGULAR;
    }
    if (selected && segment === constants_1.PARTICULARES) {
        color = next_components_text_info_n_1.TEXT_INFO_COLOR.GREY_6;
    }
    // EMPRESAS
    if (segment === constants_1.EMPRESAS) {
        color = next_components_text_info_n_1.TEXT_INFO_COLOR.GREY3;
        fontType = next_components_text_info_n_1.TEXT_INFO_FONT_WEIGHT.LIGHT;
    }
    if (selected && (segment === constants_1.EMPRESAS || isGestor)) {
        color = next_components_text_info_n_1.TEXT_INFO_COLOR.BLUE;
    }
    return {
        color,
        fontType,
    };
};
exports.setTextInfoAppearance = setTextInfoAppearance;
//# sourceMappingURL=utils.js.map